import {NgModule, Pipe, PipeTransform} from '@angular/core';
import {TextService} from '../services/text.service';

@Pipe({
	standalone: false,
	name: 'selectText'
})
export class TextSelectPipe implements PipeTransform {
	constructor(protected _text: TextService) {
	}

	transform(value: any, property?: string): string {
		return this._text.select(value, property);
	}
}

@NgModule({
	declarations: [
		TextSelectPipe
	],
	exports: [
		TextSelectPipe
	]
})
export class TextSelectPipeModule {
	
}